
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TermAcceptanceService, TermAcceptanceDto } from '../term-acceptance.service';

@Component({
    selector: 'app-term-acceptance-list',
    templateUrl: './term-acceptance-list.component.html',
    standalone: false
})
export class TermAcceptanceListComponent implements OnInit {
    items: TermAcceptanceDto[] = [];
    page = 1;
    pageSize = 20;
    totalPages = 1;
    totalItems = 0;
    fornecedorId: string = '';
    loading = false;

    constructor(
        private service: TermAcceptanceService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if (params['fornecedorId']) {
                this.fornecedorId = params['fornecedorId'];
            }
            this.load();
        });
    }

    load(): void {
        this.loading = true;
        this.service.listarAceites({
            page: this.page,
            pageSize: this.pageSize,
            fornecedorId: this.fornecedorId || undefined
        }).subscribe({
            next: (res) => {
                this.items = res.items;
                this.totalPages = res.totalPages;
                this.totalItems = res.totalItems;
                this.loading = false;
            },
            error: (err) => {
                console.error('Error loading term acceptances', err);
                this.loading = false;
            }
        });
    }

    filter(): void {
        this.page = 1;
        this.load();
    }

    resetFilter(): void {
        this.fornecedorId = '';
        this.filter();
    }

    prev(): void {
        if (this.page > 1) {
            this.page--;
            this.load();
        }
    }

    next(): void {
        if (this.page < this.totalPages) {
            this.page++;
            this.load();
        }
    }
}
